import moment from 'moment'

export const convertToMoment = (
  dateString: string,
  format: string
): moment.Moment => {
  return moment(dateString, format)
}
